import { axios } from '@/utils/request'

export function fetchList (params) {
  return axios({
    url: '/dailyInfo/selectPage',
    method: 'GET',
    params: {
      ...params
    }
  })
}
// 从sum表中取数据
export function newFetchList (params) {
  return axios({
    url: '/dailySum/page',
    method: 'GET',
    params: {
      ...params
    }
  })
}
// 刷新汇总表数据
export function refresh () {
  return axios({
    url: '/dailyInfo/refresh',
    method: 'GET'
  })
}
// 导出成本统计
export function download (params) {
  return axios({
    url: '/dailyInfo/download',
    method: 'get',
    params: params,
    responseType: 'arraybuffer'
  })
}
